import { render, staticRenderFns } from "./ArrowUpIcon.vue?vue&type=template&id=3733d58d&scoped=true&"
import script from "./ArrowUpIcon.vue?vue&type=script&lang=ts&"
export * from "./ArrowUpIcon.vue?vue&type=script&lang=ts&"
import style0 from "./ArrowUpIcon.vue?vue&type=style&index=0&id=3733d58d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3733d58d",
  null
  
)

export default component.exports